import { Parser as FormulaParser } from 'hot-formula-parser'
var parser = new FormulaParser()

parser.setFunction('NEXT_10', function (params) {
  return Math.ceil((params[0] + 1) / 10) * 10
})

parser.setFunction('PREV_10', function (params) {
  return Math.floor((params[0] - 1) / 10) * 10
})

parser.setFunction('NEXT_EVEN', function (params) {
  return params[0] + 2 - params[0] % 2
})

parser.setFunction('NEXT_ODD', function (params) {
  return params[0] + 1 + params[0] % 2
})

parser.setFunction('PREV_EVEN', function (params) {
  return params[0] - 2 + params[0] % 2
})

parser.setFunction('PREV_ODD', function (params) {
  return params[0] - 1 - params[0] % 2
})

parser.setFunction('BOND_TO', function (params) {
  return params[0] - params[1]
})

parser.setFunction('TENS', function (params) {
  return Math.floor(params[0] / 10) * 10
})

parser.setFunction('UNITS', function (params) {
  return params[0] % 10
})


function hasVariables(value) {
  return /@/i.test(value)
}

function hasFormulas(value) {
  return /[\{\}]/g.test(value)
}

function parseVariables(value, vars) {
  let parsed = value
  if (vars.value_1 || vars.value_1 === 0) {
    parsed = parsed.replace(/@V1/g, vars.value_1)
  }
  if (vars.value_2 || vars.value_2 === 0) {
    parsed = parsed.replace(/@V2/g, vars.value_2)
  }
  if (vars.value_3 || vars.value_3 === 0) {
    parsed = parsed.replace(/@V3/g, vars.value_3)
  }
  if (vars.answer || vars.answer === 0) {
    parsed = parsed.replace(/@A/g, vars.answer)
  }
  if (vars.requiredAnswer || vars.requiredAnswer === 0) {
    parsed = parsed.replace(/@RA/g, vars.requiredAnswer)
  }
  //parsed = parsed.replace(/@\w{1,2}/g, '')
  if (hasVariables(parsed)) {
    return false
  }
  return parsed
}

function parseFormula(value) {
  let parsed = value
  let i = 0
  do {
    i++
    let match = parsed.match(/\{.*?\}/)
    if (match && match[0]) {
      let clc = parser.parse(match[0].replace(/[\{\}]/g, ''))
      if (clc && !clc.error) {
        parsed = parsed.replace(match[0], clc.result)
      } else {
        parsed = parsed.replace(match[0], '')
      }
    }
  } while (hasFormulas(parsed) && i < 100)
  return parsed
}

function parseRange(range, settings) {
  const rangeConfigs = range.split(',')
  let rangeEntries = []
  rangeConfigs.forEach((item, index) => {
    if (isNaN(item)) {
      const rangeBetween = item.split('-')
      const start = rangeBetween[0]
      const end = rangeBetween[1]
      const step = settings.step || 1
      if (start && end) {
        for (let i = +start; i <= +end; i+= +step) {
          rangeEntries.push(i)
        }
      }
    } else {
      rangeEntries.push(+item)
    }
  })
  return rangeEntries
}

function parseQuestion(question, values, requiredAnswer) {
  let vars = {
    value_1: values.value_1,
    value_2: values.value_2,
    answer: values.answer,
    requiredAnswer
  }
  let parsed = parseVariables(question, vars)
  return parseFormula(parsed)
}

function parseSettings(value) {
  let result = value.split('##')
  let settingsString = result instanceof Array && result.length > 0 ? result.pop() : null
  let settings = {}
  if (settingsString) {
    let settingsValues = settingsString.split(',')
    settingsValues.forEach(value => {
      value = value.trim()
      let settingsItem = value.split('=')
      if (settingsItem instanceof Array && settingsItem.length > 1) {
        settings[settingsItem[0].trim()] = settingsItem[1].trim()
      }
    })
  }
  return settings
}

function trimSettings(value) {
  let result = value.split('##')
  return result instanceof Array ? result[0] : result

}

export default {
  hasVariables,
  parseVariables,
  parseFormula,
  parseRange,
  parseQuestion,
  parseSettings,
  trimSettings
}


// WEBPACK FOOTER //
// ./src/services/parser.services.js